import * as yup from 'yup';
import { object } from 'yup';
import { DateTime } from 'luxon';
import {
  DocumentCategoriesByName,
  requiresGoodThroughDate,
} from '../../../../types/order/documents/IDocumentCategoryType';

export const uploadDocumentValidation = (categoriesByName: DocumentCategoriesByName) =>
  yup.object({
    files: yup.array(
      yup.object({
        file: yup.mixed().required().nullable(),
        isRepeatable: yup.boolean().required(),
        category: yup.string().required(),
        metadata: yup.object().when('category', {
          is: (value?: string) => requiresGoodThroughDate(value, categoriesByName),
          then: object({
            originalFileName: yup.string().nullable(),
            good_through_date: yup
              .string()
              .required('Value is Required')
              .test('good_through_date', 'Enter a valid value', (value?: string) => {
                return value ? DateTime.fromISO(value).isValid : false;
              })
              .nullable(),
          }),
          otherwise: object({
            originalFileName: yup.string().nullable(),
            goodThroughDate: yup.string().nullable(),
          }),
        }),
      })
    ),
  });
